import React, { useState } from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'
import Image from 'next/image'

type AccordionProps = {
  children: React.ReactNode
  header: string
  isOpen?: boolean
  className?: string
  classNameActive?: string
  onClick?: () => void
}
export const Accordion = ({
  children,
  header,
  isOpen = false,
  className,
  classNameActive = '',
  onClick,
}: AccordionProps) => {
  const [open, setOpen] = useState(isOpen)
  const handleToggle = () => {
    setOpen(!open)
    onClick()
  }

  return (
    <>
      <div onClick={() => handleToggle()}>
        <div className={clsx(styles.header, className, classNameActive)}>
          {header}
          <Image
            src={`/assets/icons/${
              open ? 'icon-arrow-up-new.svg' : 'icon-arrow-down-new.svg'
            }`}
            width='20'
            height='20'
            alt='arrow up icon'
          />
        </div>
      </div>
      <div
        className={clsx(styles.accordionData, {
          [styles.accordionOpen]: open,
        })}
      >
        {children}
      </div>
    </>
  )
}
